import { render, staticRenderFns } from "./MobileRedirect.vue?vue&type=template&id=5680c020&scoped=true&"
import script from "./MobileRedirect.vue?vue&type=script&lang=js&"
export * from "./MobileRedirect.vue?vue&type=script&lang=js&"
import style0 from "./MobileRedirect.vue?vue&type=style&index=0&id=5680c020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5680c020",
  null
  
)

export default component.exports